export default __webpack_public_path__ + "static/images/f4d47e45.png";